import { render, staticRenderFns } from "./Expression.vue?vue&type=template&id=649e6af2&scoped=true&"
import script from "./Expression.vue?vue&type=script&lang=ts&"
export * from "./Expression.vue?vue&type=script&lang=ts&"
import style0 from "./Expression.vue?vue&type=style&index=0&id=649e6af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e6af2",
  null
  
)

export default component.exports